import React, { FunctionComponent, ReactElement, ReactNode } from 'react';
import { useTheme } from 'styled-components';

import { MessageType } from '@savgroup-front-common/types';

import { Skeleton } from '../../atoms/Skeleton';
import { useIsNewUiEnabled } from '../../hooks/useIsNewUiEnabled';

import { $Header, $HeaderTitle, $HeadingCustomized } from './PageHeader.styles';

interface PageHeaderProps {
  level?: number;
  postTitle?: ReactNode;
  icon?: ReactElement;
  copy?: MessageType | string;
  isLoading?: boolean;
  dataTestId?: string;
  hasMargin?: boolean;
}

const PageHeader: FunctionComponent<
  React.PropsWithChildren<PageHeaderProps>
> = ({
  level = 1,
  children,
  postTitle,
  icon,
  isLoading = false,
  copy,
  dataTestId,
  hasMargin = true,
}) => {
  const isNewUiEnabled = useIsNewUiEnabled();
  const theme = useTheme();

  return (
    <$Header $hasMargin={hasMargin}>
      <$HeaderTitle>
        <$HeadingCustomized
          level={level}
          copy={copy}
          icon={icon}
          dataTestId={dataTestId}
          color={isNewUiEnabled ? theme.newUI.defaultColors.primary : undefined}
        >
          {!isLoading ? (
            children
          ) : (
            <Skeleton highContrast width="250px" isInline />
          )}
        </$HeadingCustomized>
      </$HeaderTitle>
      {postTitle && <div>{postTitle}</div>}
    </$Header>
  );
};

export default PageHeader;
